import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { translations } from '../../data/translation';

import ng_main_01 from '../../images/ng_main_01.png';
import ng_main_02 from '../../images/메인배너.jpg';
import ng_main_03 from '../../images/ng_main_03.jpg';
import ng_main_04 from '../../images/ng_main_04.jpg';
import ng_main_05 from '../../images/ng_main_05.jpg';
import ng_main_06 from '../../images/ng_main_06.jpg';
import ng_main_07 from '../../images/ng_main_07.jpg';

import ng_main_01_eng from '../../images/ng_main_01_eng.png';
import ng_main_02_eng from '../../images/ng_main_02_eng.jpg';
import ng_main_03_eng from '../../images/ng_main_03_eng.jpg';
import ng_main_04_eng from '../../images/ng_main_04_eng.jpg';
import ng_main_05_eng from '../../images/ng_main_05_eng.jpg';
import ng_main_07_eng from '../../images/ng_main_07_eng.jpg';

export default function Main() {
  const language = useSelector(state => state.language.language);

  /* 스크롤 시 매번 getBoundingClientRect + classList 조작 → 끊김/갇힘 유발. Intersection Observer로 교체 */
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add('active');
          else entry.target.classList.remove('active');
        });
      },
      { root: null, rootMargin: '0px 0px -200px 0px', threshold: 0 }
    );

    reveals.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const t = translations[language];

  return (
    <>
      {/* <!--메인상단이미지:start--> */}
      <section className="main_box_01">
        <div className="main_01_001 fadeinUp_01">
          <small>{t.greeting}</small>
          <h2>
            {t.headlineLine1}
            <br />
            {t.headlineLine2}
          </h2>
        </div>
        <img
          className="fadeinUp_02 main_box_02_img"
          src={language === 'en' ? ng_main_01_eng : ng_main_01}
          alt="ng_main_01"
        />
      </section>
      {/* <!--메인상단이미지:end--> */}

      {/* <!--contants:start--> */}
      <main>
        <section className="contants_box contants_box_01">
          {/* <!--QR Code Article--> */}
          <article className="reveal main_box_02">
            <div className="main_02_001">
              <h3>
                {t.qrCodeTitleLine1}
                <br />
                {t.qrCodeTitleLine2}
              </h3>
              <p>
                {t.qrCodeDescriptionLine1}
                <br />
                {t.qrCodeDescriptionLine2}
              </p>
            </div>
            <div>
              <img
                className="main_box_02_img main_box_02_img--ng02"
                src={language === 'en' ? ng_main_02_eng : ng_main_02}
                alt="ng_main_02"
              />
            </div>
          </article>

          {/* <!--Promotion Article--> */}
          <article className="reveal main_box_02">
            <div className="main_02_001">
              <h3>
                {t.promotionTitleLine1}
                <br />
                {t.promotionTitleLine2}
              </h3>
              <p>
                {t.promotionDescriptionLine1}
                <br />
                {t.promotionDescriptionLine2}
                <br />
                {t.promotionDescriptionLine3}
              </p>
            </div>
            <div>
              <img
                className="main_box_02_img"
                src={language === 'en' ? ng_main_03_eng : ng_main_03}
                alt="ng_main_03"
              />
            </div>
          </article>

          {/* <!--Scan Article--> */}
          <article className="reveal main_box_02">
            <div className="main_02_001">
              <h3>
                {t.scanTitleLine1}
                <br />
                {t.scanTitleLine2}
              </h3>
              <p>
                {t.scanDescriptionLine1}
                <br />
                {t.scanDescriptionLine2}
              </p>
            </div>
            <div>
              <img
                className="main_box_02_img"
                src={language === 'en' ? ng_main_04_eng : ng_main_04}
                alt="ng_main_04"
              />
            </div>
          </article>

          {/* <!--Redeem Article--> */}
          <article className="reveal main_box_02">
            <div className="main_02_001">
              <h3>
                {t.redeemTitleLine1}
                <br />
                {t.redeemTitleLine2}
              </h3>
              <p>
                {t.redeemDescriptionLine1}
                <br />
                {t.redeemDescriptionLine2}
              </p>
            </div>
            <div>
              <img
                className="main_box_02_img"
                src={language === 'en' ? ng_main_05_eng : ng_main_05}
                alt="ng_main_05"
              />
            </div>
          </article>

          {/* <!--Sales Article--> */}
          <article className="reveal main_box_02">
            <div className="main_02_001">
              <h3>
                {t.salesTitleLine1}
                <br />
                {t.salesTitleLine2}
              </h3>
              <p>
                {t.salesDescriptionLine1}
                <br />
                {t.salesDescriptionLine2}
              </p>
            </div>
            <div>
              <img
                className="main_box_02_img"
                src={ng_main_06}
                alt="ng_main_06"
              />
            </div>
          </article>

          {/* <!--Payment Conditions Article--> */}
          <article className="reveal main_box_02">
            <div className="main_02_001">
              <h3>
                {t.paymentTitleLine1}
                <br />
                {t.paymentTitleLine2}
              </h3>
              <p>
                {t.paymentDescriptionLine1}
                <br />
                {t.paymentDescriptionLine2}
                <br />
                {t.paymentDescriptionLine3}
              </p>
              <small>
                {t.paymentNoteStorePgShort}
                <br />
                {t.paymentNoteDepositDetail}
                <br />
                {t.paymentNoteLine3}
                <br />
                {t.paymentNoteRefund}
              </small>
            </div>
            <div>
              <img
                className="main_box_02_img"
                src={language === 'en' ? ng_main_07_eng : ng_main_07}
                alt="ng_main_07"
              />
            </div>
          </article>

          {/* <!--상점 참여 CTA 섹션--> */}
          <article className="reveal main_store_join_cta">
            <div className="main_store_join_illust">
              <svg
                viewBox="0 0 120 80"
                fill="none"
                stroke="#c99a6e"
                strokeWidth="1.5"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M20 60 L20 25 Q20 15 35 15 L60 15" />
                <path d="M100 60 L100 25 Q100 15 85 15 L60 15" />
                <path d="M60 15 L60 65" />
                <ellipse cx="35" cy="42" rx="8" ry="3" />
                <rect x="30" y="42" width="10" height="12" rx="1" />
                <path d="M42 38 L46 35" />
                <path d="M75 45 Q85 35 85 45 Q85 55 75 50 Q70 48 75 45" />
              </svg>
            </div>
            <div className="main_store_join_content">
              <h3>{t.storeJoinHeading}</h3>
              <p>{t.storeJoinDescription}</p>
              <button
                type="button"
                className="main_store_join_btn"
                onClick={() =>
                  window.open('https://cafe.naver.com/naegift', '_blank')
                }
              >
                {t.storeJoinButton}
              </button>
            </div>
          </article>
        </section>
      </main>
      {/* <!--contants:end--> */}
    </>
  );
}
